/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import Carousel from '../../Carousel';
import { formatProductsByType, onSelectAddOnCarouseHandler } from '../../../utils/products';
import { Card, CardHeader, Container, Row, Col } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import Summary from '../../Summary';
import { useResponsiveValue } from '@theme-ui/match-media';
import { RulesType, RulesName } from '../../../enums';

export default ({
  selectedPlan,
  history,
  client,
  shoppingCart,
  addProduct,
  user,
  addOnsToShow,
  addOnList,
  setAddOnsToShow,
  deleteCouponCode,
  applyProductRules,
  couponApply,
  subscriptions,
  intl
}) => {
  const { exchangeRate } = user;
  const numberOfCards = useResponsiveValue([1, 2, 2, 2]);
  const slidesToScroll = useResponsiveValue([1]);
  const showSlither = useResponsiveValue([false, true, false]);
  const outsideChevron = useResponsiveValue([false, true, false]);
  const formattedAddOnsToCarousel = formatProductsByType(addOnsToShow || addOnList);
  if (!selectedPlan) {
    return <Redirect to={`/${client}/subscribe/subscriptions${history.location.search}`} />;
  }
  const handleContinueClick = () => {
    history.push('../methods' + history.location.search);
  };

  useEffect(() => {
    if (addOnsToShow.length === 0) {
      applyProductRules({ ruleType: RulesType.ADDITIONAL_PURCHASE, ruleName: RulesName.PLAN_ADDONS_OFFERING, productId: selectedPlan.productID });
      applyProductRules({ ruleType: RulesType.PURCHASE, ruleName: RulesName.PLAN_INCLUDE_ADDONS, productId: selectedPlan.productID });
    }
  }, [addOnsToShow]);

  useEffect(() => {
    // if exchange rate change in payment form, reset summary to original user currency
    if (shoppingCart.exchange?.currency && shoppingCart.exchange.currency !== user.currency) {
      // TODO: Revisar implementacion
    }
    // if apply a coupon on payment form, delete coupon for clean summary
    if (couponApply.code) {
      deleteCouponCode();
    }
  }, [user.currency, couponApply]);

  return (
    <Container className="MembershipSelectionPage">
      <div className="myaccount-title">
        <p className="h6 text-uppercase">
          <FormattedMessage
            id="MyAccount.title"
          />
        </p>
      </div>
      <Row>
        <Col className="tbx-carousel-addOns-container">
          {Object.entries(formattedAddOnsToCarousel).map(([addOnType, addOnList]) => {
            return (
              <Card className="tbx-card-carousel" key={addOnType}>
                <CardHeader className="tbx-card-header">
                  <h4 className="tbx-card-carousel__title">
                    <FormattedMessage id={addOnType} />
                  </h4>
                </CardHeader>
                <Carousel
                  intl={intl}
                  client={client}
                  carouselOptions={{
                    numberOfCards, showSlither, outsideChevron, slidesToScroll
                  }}
                  exchangeRate={exchangeRate}
                  userPlan={selectedPlan}
                  onSelect={(item) => {
                    onSelectAddOnCarouseHandler(item, (addOnsToShow || addOnList), setAddOnsToShow, addProduct)
                  }}
                  products={addOnList}
                />
              </Card>
            )
          })}
        </Col>
        <Col className="summary-content left">
          <div className="summary-content-body">
            <Summary
              subscriptions={subscriptions}
              selectedProducts={shoppingCart?.productsToBuy}
              handleContinueButton={handleContinueClick}
              user={user}
            />
          </div>
        </Col>
      </Row>
    </Container>)
};
